export type VinteraTopNavigationContext =
  | "customer_portal"
  | "public"
  | "staff_workspace";

const adminAuthenticationPaths = [
  "/admin/login",
  "/admin/forgot-password",
  "/admin/reset-password",
  "/admin/mfa",
];

function isPathWithin(pathname: string, route: string) {
  return pathname === route || pathname.startsWith(`${route}/`);
}

export function resolveVinteraTopNavigationContext(
  pathname: string,
): VinteraTopNavigationContext {
  if (isPathWithin(pathname, "/portal")) return "customer_portal";
  if (
    isPathWithin(pathname, "/admin")
    && !adminAuthenticationPaths.some((route) => isPathWithin(pathname, route))
  ) return "staff_workspace";
  return "public";
}
